/*jshint esversion: 6 */
import {
    addActionClass,
    addErrorClass,
    addLoadingClass,
    addSuccessClass,
    removeLoadingClass
} from "../../../default/global/js/utilities/updateClasses";
import {itemcardSubscriptions} from "../../../default/global/js/subscriptions";
import {hideIconbarHover, initIconbarHoverClose, showIconbarHover} from "../../../default/global/js/iconbarHover";
import {initCustomSelects} from "../../../default/global/js/customSelect";
import {initToggleSlide} from "../../../default/global/js/toggle";
import {XhrService} from "../../../default/global/ts/xhr.service";
import {appendScriptToDOM} from "../../../default/global/js/utilities/functions";
import {initFormSubmitChanges} from "../../../default/global/js/actionClick";
import {closeModal, showModal} from "../../../default/global/js/modal";
import {initInputBody} from "../../../default/global/js/inputfile";
import {focusInputGroups} from "../../../default/global/js/checkInputGroups";
import {updateItemlistStickyOrderBarCount} from "../../../default/global/js/itemlistStickyOrderBar";
import {getAllQuantityInputs} from "../../../default/global/js/quantitySpinner";

function updateBasketCount(doc) {
    for (let basketCount of document.querySelectorAll('.js-basketCount')) {
        let firstNewBasketCount = doc.querySelector('.js-basketCount');
        if (firstNewBasketCount) {
            let count = parseInt(firstNewBasketCount.innerText);
            if (isNaN(count)) {
                count = 0;
            }
            if (count === 0) {
                basketCount.style.display = "none";
            } else {
                addActionClass(basketCount, function () {
                    basketCount.style.display = "";
                });
            }
        }
    }
}

function updateItem(target, doc) {
    let dataItemNo = target.dataset.itemNo;
    if (dataItemNo) {
        let addOn = target.closest(".js-updateItem");
        if (addOn) {
            let newTarget = doc.querySelector('.js-addListItemToBasket[data-item-no="' + dataItemNo + '"]');
            if (newTarget) {
                let newaddOn = newTarget.closest('.js-updateItem');
                if (newaddOn) {
                    addOn.innerHTML = newaddOn.innerHTML;
                } else {
                    console.error("cannot update orderbutton");
                }
            }
        }
    }
}

function updateOrderButtonItemcard(doc) {
    let itemcardBuybox = document.querySelector(".itemcardBuybox");
    let newItemcardBuybox = doc.querySelector('.itemcardBuybox');

    if (itemcardBuybox) {
        itemcardBuybox.innerHTML = newItemcardBuybox.innerHTML;

        itemcardSubscriptions(itemcardBuybox);
        initCustomSelects(itemcardBuybox.querySelectorAll(".js-customSelect"));
    }
}

function updateHeaderBasket(doc) {
    let delayBasketHover = 6000;
    if(GLOBALS){
        if(GLOBALS.delayHideBasketHover){
            delayBasketHover = GLOBALS.delayHideBasketHover;
        }
    }
    for (let headerBasket of document.querySelectorAll('.js-headerBasket')) {
        let newHeaderBasket = doc.querySelector('.js-headerBasket');
        if (newHeaderBasket) {
            headerBasket.innerHTML = newHeaderBasket.innerHTML;
            headerBasket.classList.add("showIconbarHover");
            showIconbarHover(headerBasket);
            initIconbarHoverClose(headerBasket.querySelectorAll(".iconbarHover__close"));
            let basketCount = headerBasket.querySelector('.js-basketCount');

            if (basketCount) {
                addActionClass(basketCount);
            }

            setTimeout(function () {
                hideIconbarHover(headerBasket);
            }, delayBasketHover);
        }
    }
}

function dispatchCustomUpdateBasketViewsEvent(data,name="updateBasketViews"){
    document.dispatchEvent(new CustomEvent(name, {
        detail: { data }
    }));
}

function eventListenerBasketViewQuantities(basketView, updateTimeout) {
    for (let quantity of basketView.querySelectorAll('.js-itemBasketList .quantity input[type="number"]')) {
        let form = quantity.closest(".js-itemBasketList");
        quantity.addEventListener("change", function () {
            clearTimeout(updateTimeout);
            updateTimeout = setTimeout(function () {
                sendBasketForm(form, basketView);
            }, 1000);
        });
        quantity.addEventListener("keyup", function (e) {
            if(e.key === "Enter"){
                sendBasketForm(form, basketView);
            }
        });
    }
}

function eventListenerBasketViewSpDiscounts(basketView, updateTimeout) {
    for (let spDiscount of basketView.querySelectorAll('.js-itemBasketList .spDiscount input[type="number"]')) {
        let form = spDiscount.closest(".js-itemBasketList");
        let max = spDiscount.max;
        let value = spDiscount.value;
        spDiscount.addEventListener("change", function () {
            clearTimeout(updateTimeout);
            updateTimeout = setTimeout(function () {
                sendBasketForm(form, basketView);
            }, 1000);
        });
        spDiscount.addEventListener("keyup", function (e) {
            if(e.key === "Enter"){
                sendBasketForm(form, basketView);
            }
        });
    }

}

function eventListenerBasketViewQuantitySpinners(basketView, updateTimeout) {
    for (let spinner of basketView.querySelectorAll('.js-itemBasketList .quantity .js-spinnerUp,.js-itemBasketList .quantity .js-spinnerDown')) {
        let form = spinner.closest(".js-itemBasketList");
        spinner.addEventListener("click", function () {
            clearTimeout(updateTimeout);
            updateTimeout = setTimeout(function () {
                sendBasketForm(form, basketView);
            }, 1000);
        });
    }
}

function updateAllBasketViews(basketView, newBasketView) {
    if (basketView && newBasketView) {
        let oldList = basketView.querySelector('.js-itemBasketList');
        let oldOrderBox = basketView.querySelector('.js-basketOrderBox');
        let oldSummary = basketView.querySelector('.js-basketSummary');
        let oldBasketPaymentButtons = basketView.querySelector('.js-basketPaymentButtons');

        let newList = newBasketView.querySelector('.js-itemBasketList');
        let newOrderBox = newBasketView.querySelector('.js-basketOrderBox');
        let newSummary = newBasketView.querySelector('.js-basketSummary');
        let newBasketPaymentButtons = newBasketView.querySelector('.js-basketPaymentButtons');

        if (newList) {
            oldList.innerHTML = newList.innerHTML;
            removeLoadingClass(oldList);
            eventListenerBasketViewQuantities(basketView);
            eventListenerBasketViewQuantitySpinners(basketView);
            eventListenerBasketViewSpDiscounts(basketView);
        } else {
            basketView.innerHTML = newBasketView.innerHTML;
            return;
        }

        if (newOrderBox) {
            oldOrderBox.innerHTML = newOrderBox.innerHTML;
            removeLoadingClass(oldOrderBox);
            initToggleSlide(oldOrderBox.querySelectorAll(".js-toggleLinkSlide"));
            initFormSubmitChanges();
        }
        if (newSummary) {
            oldSummary.innerHTML = newSummary.innerHTML;
        }

        if (newBasketPaymentButtons) {
            oldBasketPaymentButtons.innerHTML = newBasketPaymentButtons.innerHTML;
            executeScripts(oldBasketPaymentButtons);
        }
    }
}

function executeScripts(element) {
    let scripts = element.querySelectorAll('script');

    scripts.forEach(script => {
        let newScript = document.createElement('script');
        newScript.src = script.src;
        document.head.appendChild(newScript);
        newScript.remove();
    });
}

function sendBasketForm(form, basketView) {
    let formData = new FormData(form);
    addLoadingClass(basketView.querySelector('.js-itemBasketList'));
    addLoadingClass(basketView.querySelector('.js-basketOrderBox'));
    fetch(form.action, {
        method: "POST",
        body: formData,
    })
        .then((response) => {
            if (!response.ok) {
                throw "Could not save data";
            }
            return response.text();
        })
        .then((data) => {
            let parser = new DOMParser();
            let doc = parser.parseFromString(data, "text/html");
            updateAllBasketViews(basketView, doc.getElementById('userBasket'));

            dispatchCustomUpdateBasketViewsEvent({
                data
            });

            console.log('Success:', data);
        })
        .catch((e) => {
            console.error('Error:', e);
        });
}

export function triggerBasketBtns() {
    document.addEventListener("click", function (e) {
        let target = e.target;

        if (target.closest(".js-addListItemToBasket")) {
            target = target.closest(".js-addListItemToBasket");
            let form = target.closest("form");
            let orderButtonWrapper = target.closest(".orderButtonWrapper");
            let quantityInput = orderButtonWrapper.querySelector('.js-quantity-value');

            if (form && quantityInput) {
                if (quantityInput.value > 0) {
                    addLoadingClass(target);
                    let formData = new FormData(form);
                    let action = form.dataset.action;
                    formData.set('action', action);
                    XhrService.generalAjaxCall('cart', formData, 'POST', 'json').then(response => {
                        if (!response.status) {
                            throw "Could not save data";
                        }
                        const headerBasket = document.querySelector('.js-headerBasket');
                        if (headerBasket && response.headerBasketContent) {
                            var doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                            updateHeaderBasket(doc);
                        }
                        if (response.tagManager) {
                            appendScriptToDOM(response.tagManager, true);
                        }
                        form.reset();
                        addSuccessClass(target);
                        updateItemlistStickyOrderBarCount();
                        return response.status;
                    })
                        .catch((e) => {
                            addErrorClass(target);
                            console.error('Error:', e);
                            console.error('Action:', form.action);
                            console.error(formData);
                        });
                }

            }
            e.preventDefault();
        }

        if (target.closest(".js-addToBasketItemcard")) {
            target = target.closest(".js-addToBasketItemcard");
            let form = target.closest("form");
            let orderButtonWrapper = target.closest(".orderButtonWrapper");
            let quantityInput = orderButtonWrapper.querySelector('.js-quantity-value');
            let customizableInputValue = form.dataset.customized;
            let quantityValue = 0;

            if ((form && quantityInput) || (form && customizableInputValue === '1'))  {
                if (quantityInput) {
                    quantityValue = quantityInput.value;
                }
                if (quantityValue > 0 || customizableInputValue === '1') {
                    addLoadingClass(target);
                    let fn = 'cart';
                    let formData = new FormData(form);
                    let action = form.dataset.action;
                    formData.set('action', action);
                    if (customizableInputValue === '1') {
                        fn = 'cartCustomize';
                    }

                    XhrService.generalAjaxCall(fn, formData, 'POST', 'json').then(response => {
                        if (!response.status) {
                            throw "Could not save data";
                        }
                        addSuccessClass(target);
                        if (fn == 'cartCustomize') {
                            let existingModal = document.getElementById('modalUserQueue');
                            if (existingModal) {
                                existingModal.remove();
                            }

                            const parser = new DOMParser();
                            const customizeModalParser = parser.parseFromString(response.customizeModal, 'text/html');
                            const customizeModal = customizeModalParser.querySelector('.modal');

                            if(customizeModal){
                                document.body.appendChild(customizeModal);
                                initInputBody(customizeModal.querySelectorAll(".fileBody"));
                                focusInputGroups(customizeModal.querySelectorAll('.inputGroup input,.inputGroup select,.inputGroup textarea'));
                                showModal(customizeModal);
                                loadCustomization();
                                scaleFontSize(customizeModal);

                                const resizeObserver = new ResizeObserver((entries) => {
                                    scaleFontSize(customizeModal);
                                });
                                resizeObserver.observe(document.body);
                            }
                        } else {
                            const headerBasket = document.querySelector('.js-headerBasket');
                            if (headerBasket && response.headerBasketContent) {
                                var doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                                updateHeaderBasket(doc);
                            }
                            if (response.tagManager) {
                                appendScriptToDOM(response.tagManager, true);
                            }
                            form.reset();
                            let existingModal = document.getElementById('modalUserQueue');
                            if (existingModal) {
                                closeModal(existingModal);
                            }
                        }

                        return response.status;
                    })
                        .catch((e) => {
                            addErrorClass(target);
                            console.error('Error:', e);
                        });
                }
            }
            e.preventDefault();
        }

        if (target.closest(".js-removeFromBasketHover")) {
            target = target.closest(".js-removeFromBasketHover");

            addLoadingClass(target);
            let formData = new FormData();
            formData.set('action', target.dataset.action);
            formData.set('action_id', target.dataset.actionid);
            formData.set('var_code', target.dataset.var_code);
            formData.set('item_key', target.dataset.itemkey);


            XhrService.generalAjaxCall('cart', formData, 'POST', 'json').then(response => {
                addSuccessClass(target);
                if (!response.status) {
                    throw "Could not save data";
                }
                addSuccessClass(target);
                const headerBasket = document.querySelector('.js-headerBasket');
                if (headerBasket && response.headerBasketContent) {
                    var doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                    updateHeaderBasket(doc);
                }
                if (response.tagManager) {
                    appendScriptToDOM(response.tagManager, true);
                }
                return response.status;
            })
                .catch((e) => {
                    addErrorClass(target);
                    console.error('Error:', e);
                });
            e.preventDefault();
        }

        if (target.closest(".js-saveBasketCustomization")) {
            target = target.closest(".js-saveBasketCustomization");
            addLoadingClass(target);

            let form = target.closest("form");
            let formData = new FormData(form);
            formData.set('action', form.dataset.action);

            XhrService.generalAjaxCall('saveCustomization', formData, 'POST', 'json').then(response => {
                if (!response.status) {
                    throw "Could not save data";
                }
                addSuccessClass(target);
                let customizationData = response.inputDataArray;
                let hash = customizationData.action_id;

                let itemBasketBox = document.querySelector(".itemBasketBox[data-customizationHash='" + hash + "']");

                Object.keys(customizationData).forEach(key => {
                    let cleanKey = key.replace("input", "");
                    let customizationText = document.getElementById(cleanKey);
                    if(customizationText) {
                        customizationText.innerHTML = customizationData[key];
                    }
                    if(key === "color_description" && itemBasketBox) {
                        let colorDescriptionSpan = itemBasketBox.querySelector(".js-basketCustomizationColorName");
                        if(colorDescriptionSpan) {
                            colorDescriptionSpan.innerHTML = customizationData[key];
                        }
                    }

                    if(key === "color_code" && itemBasketBox) {
                        let colorCodeSpan = itemBasketBox.querySelector(".js-basketCustomizationColorHex");
                        if(colorCodeSpan) {
                            colorCodeSpan.style.backgroundColor = customizationData[key];
                        }
                    }
                });
                form.reset();
                let existingModal = document.getElementById('modalUserQueue');
                if (existingModal) {
                    closeModal(existingModal);
                }
            })
                .catch((e) => {
                    addErrorClass(target);
                    console.error('Error:', e);
                });

            e.preventDefault();
        }

        if (target.closest(".js-basketEditCustomization")) {
            target = target.closest(".js-basketEditCustomization");
            addLoadingClass(target);

            let formData = new FormData();
            formData.set('action', target.dataset.action);
            formData.set('action_id', target.dataset.actionid);
            formData.set('customization_hash', target.dataset.customizationhash);
            formData.set('indiv_item_var_code', target.dataset.indiv_item_var_code);

            XhrService.generalAjaxCall('editCustomization', formData, 'GET', 'json').then(response => {
                if (!response.status) {
                    throw "Could not save data";
                }
                addSuccessClass(target);

                let itemBasketList = document.getElementById('form_user_basket');
                if (itemBasketList) {
                    let existingModal = document.getElementById('modalUserQueue');
                    if (existingModal) {
                        existingModal.remove();
                    }
                    let customizeModal = response.customizeModal;
                    let newElement = document.createElement('div');
                    newElement.innerHTML = customizeModal;
                    while (newElement.firstChild) {
                        itemBasketList.appendChild(newElement.firstChild);
                    }
                    newElement.remove();
                    initInputBody(document.getElementById("modalUserQueue").querySelectorAll(".fileBody"));
                    focusInputGroups(document.getElementById("modalUserQueue").querySelectorAll('.inputGroup input,.inputGroup select,.inputGroup textarea'));
                    showModal(document.getElementById("modalUserQueue"));
                    loadCustomization();


                    scaleFontSize(document.getElementById("modalUserQueue"));

                    const resizeObserver = new ResizeObserver((entries) => {
                        scaleFontSize(document.getElementById("modalUserQueue"));
                    });
                    resizeObserver.observe(document.body);
                }

                return response.status;
            })
                .catch((e) => {
                    addErrorClass(target);
                    console.error('Error:', e);
                });

            e.preventDefault();
        }

        if (target.closest(".js-addListItemToBasketAll")) {
            target = target.closest(".js-addListItemToBasketAll");
            let quantityInputs = getAllQuantityInputs();
            let forms = new Set();

            for(let qty of quantityInputs){
                let form = qty.closest("form");
                if(form){
                    forms.add(form);
                }
            }

            if (forms) {
                let formDatas = new FormData();
                for(let form of forms){
                    let qtyInput = form.querySelector('.quantity input[type="number"]');
                    if(qtyInput){
                        if(parseInt(qtyInput.value) > 0){
                            let formData = new FormData(form);
                            for (let pair of formData.entries()) {
                                formDatas.append(pair[0], pair[1]);
                            }
                        }
                    }
                }
                addLoadingClass(target);
                formDatas.set('action', 'shop_add_all_items_to_basket');

                XhrService.generalAjaxCall('cart', formDatas, 'POST', 'json').then(response => {
                    if (!response.status) {
                        throw "Could not save data";
                    }
                    const headerBasket = document.querySelector('.js-headerBasket');
                    if (headerBasket && response.headerBasketContent) {
                        var doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                        updateHeaderBasket(doc);
                    }
                    if (response.tagManager) {
                        appendScriptToDOM(response.tagManager, true);
                    }
                    for(let form of forms){
                        form.reset();
                    }
                    updateItemlistStickyOrderBarCount();
                    addSuccessClass(target);
                    return response.status;
                })
                    .catch((e) => {
                        addErrorClass(target);
                        console.error('Error:', e);
                        console.error(formDatas);
                    });

            }
            e.preventDefault();
        }
    });
}

export function triggerUpdateBasketView() {
    let updateTimeout = false;
    let basketView = document.getElementById("userBasket");
    if (basketView) {
        eventListenerBasketViewQuantities(basketView, updateTimeout);
        eventListenerBasketViewQuantitySpinners(basketView, updateTimeout);
        eventListenerBasketViewSpDiscounts(basketView, updateTimeout);

        new CustomEvent('updateBasketViews', {
            detail: { message: 'Die Funktion wurde erfolgreich ausgeführt!' }
        });
    }
}


function loadCustomization() {
    let radios = document.querySelectorAll('.radio-customize-color');

    let inputRow1 = document.querySelector('.input-text-row-1');
    let divRow1 = document.getElementById('text-row-1');

    let inputRow2 = document.querySelector('.input-text-row-2');
    let divRow2 = document.getElementById('text-row-2');

    let btn = document.querySelector('.js-customizationAddToCart');
    let selectedColor = document.querySelector('.js-customColorSelectedColor');

    let colorSelectionHint = document.getElementById('colorSelectionHint');
    let colorRadioGroup = document.querySelector('.customColorSelectionRadios');

    let colorDescriptionEditWindow = document.getElementById("editColorDescription");
    let colorValueEditWindow = document.getElementById("editColorValue");

    if (radios.length > 0) {
        radios.forEach(radio => {
            radio.addEventListener('change', () => {
                if (radio.checked) {
                    const customizeColor = radio.getAttribute('data-color');

                    if (colorDescriptionEditWindow && colorValueEditWindow) {
                        colorDescriptionEditWindow.value = radio.dataset.colorName;
                        colorValueEditWindow.value = customizeColor;
                    }

                    if (divRow1 && divRow2) {
                        divRow1.style.color = customizeColor;
                        divRow2.style.color = customizeColor;
                    }
                    if (selectedColor) {
                        selectedColor.textContent = radio.dataset.colorName;
                    }

                    if (colorSelectionHint) {
                        colorSelectionHint.remove();
                        colorSelectionHint = null;

                        if (colorRadioGroup) {
                            colorRadioGroup.setAttribute('aria-describedby', 'colorContrastHint');
                        }
                    }
                }
                // btn-Zustand und Radio-Fokus nach dem aktuellen Event-Zyklus setzen:
                // DOM-Mutationen (disabled-Attribut) passieren asynchron, damit
                // VoiceOver die Radio-Auswahl zuerst vollständig verarbeitet.
                // Danach wird der Fokus explizit auf das Radio zurückgesetzt,
                // falls DOM-Mutationen ihn verschoben haben.
                setTimeout(() => {
                    if (btn) {
                        updateAddToCartBtnState(btn);
                    }
                    if (radio.checked) {
                        radio.focus();
                    }
                }, 0);
            });
        });
    }

    // Die Divs zeigen initial (server-seitig gerendert) einen Beispieltext
    // ("Text 1"/"Text 2"). Wird ein Feld wieder geleert, soll dieser
    // Beispieltext zurückkehren statt einer leeren Fläche.
    const row1Placeholder = divRow1 ? divRow1.textContent : '';
    const row2Placeholder = divRow2 ? divRow2.textContent : '';

    if (inputRow1 && inputRow2) {
        const allowedCharsPattern = '[äöüÄÖÜß\\x20-\\x7E]*';
        const sanitizeInput = (input) => {
            input.value = input.value.replace(/[^äöüÄÖÜß\x20-\x7E]/g, '');
        };

        [inputRow1, inputRow2].forEach(input => {
            input.setAttribute('pattern', allowedCharsPattern);
            input.setAttribute('title', input.getAttribute('title') || 'Nur lateinische Buchstaben (inkl. Umlaute), Zahlen und Standard-Sonderzeichen erlaubt');
            input.addEventListener('input', () => sanitizeInput(input));
        });

        inputRow1.addEventListener('keyup', () => {
            if (divRow1) {
                divRow1.textContent = inputRow1.value !== "" ? inputRow1.value : row1Placeholder;
            }
            updateTextRow1Position(divRow1, divRow2, inputRow1, inputRow2);
            if (inputRow2.value !== "" && inputRow1.value !== "") {
                if (btn) updateAddToCartBtnState(btn);
            }
        });

        inputRow2.addEventListener('keyup', () => {
            if (divRow2) {
                divRow2.textContent = inputRow2.value !== "" ? inputRow2.value : row2Placeholder;
            }
            updateTextRow1Position(divRow1, divRow2, inputRow1, inputRow2);
            if (inputRow2.value !== "" && inputRow1.value !== "") {
                if (btn) updateAddToCartBtnState(btn);
            }
        });
    }

    if (inputRow1 && inputRow2 && divRow1 && divRow2) {
        if (inputRow1.value !== "") {
            divRow1.textContent = inputRow1.value;
        }

        if (inputRow2.value !== "") {
            divRow2.textContent = inputRow2.value;
        }

        updateTextRow1Position(divRow1, divRow2, inputRow1, inputRow2);
    }

    if (btn) {
        updateAddToCartBtnState(btn);

        btn.addEventListener('click', (e) => {
            if (updateAddToCartBtnState(btn, true)) {
                return;
            }

            // Den eigenen Absende-Weg stoppen, damit statt des XHR-Aufrufs
            // die native Browser-Validierung die Pflichtfeld-Meldung zeigt.
            e.preventDefault();
            e.stopPropagation();

            if (radios.length > 0 && !isColorSelected(radios)) {
                radios[0].reportValidity();
            } else if (btn.form) {
                btn.form.reportValidity();
            }
        });
    }
}

/**
 * Ist Zeile 1 der Personalisierung befüllt und Zeile 2 (noch) leer, rückt
 * Zeile 1 optisch in die Mitte zwischen ihrer eigenen und der Position von
 * Zeile 2, und der Platzhaltertext "Text 2" wird ausgeblendet (er gehört ja
 * nicht zur eigentlichen Bestellung, solange niemand wirklich eine zweite
 * Zeile eingibt). In allen anderen Fällen - beide Felder leer, oder Zeile 2
 * ebenfalls befüllt - bleibt bzw. springt Zeile 1 zurück an ihre
 * ursprüngliche, admin-konfigurierte Position und Zeile 2 ist sichtbar. Die
 * Positions-Berechnung erfolgt bewusst in Prozent (data-original-top), damit
 * sie unabhängig vom Breakpoint funktioniert.
 */
function updateTextRow1Position(divRow1, divRow2, inputRow1, inputRow2) {
    if (!divRow1 || !divRow2) {
        return;
    }

    const originalTop1 = parseFloat(divRow1.dataset.originalTop);
    const originalTop2 = parseFloat(divRow2.dataset.originalTop);

    if (isNaN(originalTop1) || isNaN(originalTop2)) {
        return;
    }

    const row1HasText = !!(inputRow1 && inputRow1.value !== "");
    const row2HasText = !!(inputRow2 && inputRow2.value !== "");

    if (row1HasText && !row2HasText) {
        divRow1.style.top = ((originalTop1 + originalTop2) / 2) + '%';
    } else {
        divRow1.style.top = divRow1.dataset.originalTop;
    }

    divRow2.style.display = (row1HasText && !row2HasText) ? 'none' : '';
}

function isColorSelected(radios) {
    for (let radio of radios) {
        if (radio.checked) {
            return true;
        }
    }

    return false;
}

function updateAddToCartBtnState(btn, showMessage = false) {
    let errorMessage = document.querySelector('.customizationError');
    if(errorMessage){
        errorMessage.style.display = 'none';
    }

    // Die Pflichtfelder stehen als required im Markup. Deshalb entscheidet die
    // Constraint-Validierung des Formulars, nicht eine eigene Feldliste.
    if (!btn.form || btn.form.checkValidity()) {
        return true;
    }

    if (showMessage && errorMessage) {
        errorMessage.style.display = 'block';
    }

    return false;
}

function scaleFontSize(customizeModal) {
    if (window.innerWidth <= 714) {
        const draggableTextes = customizeModal.querySelectorAll('.draggable-text');
        for(const draggableText of draggableTextes){
            const defaultFontSize = draggableText.dataset.defaultFontSize.replace(/\D/g, '');
            draggableText.style.fontSize = (window.innerWidth - 40) / 668 * defaultFontSize + "px";
        }
    } else {
        const draggableTextes = customizeModal.querySelectorAll('.draggable-text');
        for(const draggableText of draggableTextes){
            draggableText.style.fontSize = draggableText.dataset.defaultFontSize;
        }
    }
}